export const Config = {"api_host": "/api/v1/",
  "public_client": "walmart",
  "roi_cpa_campaign_margin": 5,
  "fullDateTimeFormat": "MM-dd-yyyy HH:mm",
  "dateTimeFormat": "MM-dd-yyyy",
  "defaultTimezone": "America/Mexico_City",
  "timeFormat": "HH:mm",
  "defaultCurrency": "MXN",
  "currencySymbol": "$",
  "search_debounce_delay": 750,
  "defaultLocale": "en-US",
  "basename": "/",
  "strategy_supply_type": "WAN",
  "support_link": "mailto:DSPcontacto@walmart.com?subject=Walmart – DSP – Contacto",
  "auth0": {
    "domain": "mediamath.auth0.com",
    "clientId": "I0bI0YsJFAmGK6jMn6u7Zu7gR45mhGvX"
  },
  "defaultReportColumns": {
    "app-transparency": [
      "agency_name",
      "advertiser_name",
      "campaign_name",
      "strategy_name",
      "campaign_currency_code",
      "start_date",
      "end_date",
      "clicks",
      "ctr",
      "impressions",
      "total_conversions",
      "total_spend",
      "total_spend_cpa",
      "total_spend_cpc",
      "total_spend_cpm",
      "post_click_conversions",
      "post_view_conversions"
      ],
    "site-transparency": [
      "agency_name",
      "advertiser_name",
      "campaign_name",
      "strategy_name",
      "campaign_currency_code",
      "start_date",
      "end_date",
      "clicks",
      "ctr",
      "impressions",
      "total_conversions",
      "total_spend",
      "total_spend_cpa",
      "total_spend_cpc",
      "total_spend_cpm",
      "post_click_conversions",
      "post_view_conversions"
      ],
    "geo": [
      "agency_name",
      "advertiser_name",
      "campaign_name",
      "strategy_name",
      "campaign_currency_code",
      "start_date",
      "end_date",
      "clicks",
      "ctr",
      "impressions",
      "total_conversions",
      "total_spend",
      "total_spend_cpa",
      "total_spend_cpc",
      "total_spend_cpm",
      "post_click_conversions",
      "post_view_conversions"
      ],
    "performance": [
      "agency_name",
      "advertiser_name",
      "campaign_name",
      "strategy_name",
      "start_date",
      "end_date",
      "impressions",
      "clicks",
      "total_spend",
      "total_conversions",
      "total_revenue",
      "total_spend_cpm",
      "ctr",
      "total_spend_cpc",
      "total_spend_cpa",
      ],
    "new-to-brand": [
      "agency_name",
      "campaign_id",
      "campaign_name",
      "total_conversions",
      "total_conversions_revenue",
      "total_unique_converters",
      "total_spend",
      "total_ntb_conversions",
      "total_ntb_revenue",
      "total_ntb_converters",
      "incremental_roas",
      ],
    "omnichannel-attribution": [
      "advertiser_id",
      "advertiser_name",
      "agency_name",
      "campaign_id",
      "campaign_name",
      "total_spend",
      "clicks",
      "impressions",
      "total_online_conversions",
      "total_offline_conversions",
      "total_online_revenue",
      "total_offline_revenue",
      "total_spend_online_roi",
      "total_spend_offline_roi",
      "total_conversions",
      "total_revenue",
      "total_spend_roi"
    ],
    "audience": [
      "advertiser_id",
      "advertiser_name",
      "audience_segment_name",
      "audience_vendor_name",
      "campaign_id",
      "campaign_name",
      "clicks",
      "end_date",
      "impressions",
      "start_date",
      "strategy_channel",
      "strategy_name",
      "strategy_type",
      "total_conversions",
      "total_offline_conversions",
      "total_offline_revenue",
      "total_online_conversions",
      "total_online_revenue",
      "total_revenue",
      "total_spend",
      "total_spend_offline_roi",
      "total_spend_online_roi",
      "total_spend_roi",
    ],
    "retail-attribution": [
      "advertiser_name",
      "advertiser_id",
      "agency_name",
      "agency_id",
      "campaign_name",
      "campaign_id",
      "start_date",
      "end_date",
      "product_brand",
      "product_id",
      "total_ppv",
      "total_atc",
      "abandonment_rate",
      "total_orders",
      "online_orders",
      "offline_orders",
      "total_units",
      "online_units",
      "offline_units",
      "total_product_revenue",
      "online_product_revenue",
      "offline_product_revenue",
      "total_roi",
      "online_roi",
      "offline_roi",
      "total_spend",
    ],
  },
  "hideReportColumns": {
    "app-transparency": ["video_close", "video_collapse", "video_companion_clicks", "video_companion_ctr", "video_companion_impressions"],
    "site-transparency": ["video_close", "video_collapse", "video_companion_clicks", "video_companion_ctr", "video_companion_impressions"],
    "geo": ["video_close", "video_collapse", "video_companion_clicks", "video_companion_ctr", "video_companion_impressions"],
    "performance": ["concept_id", "concept_name", "client_product_estimate", "io_number", "prisma_campaign_id", "tpas_placement_id", "tpas_placement_name", "3pa_conversions", "3pa_media_cost_cpa", "3pa_media_cost_cpa_usd", "3pa_media_cost_roi", "3pa_rr_per_1k_imps", "3pa_total_ad_cost_cpa", "3pa_total_ad_cost_cpa_usd", "3pa_total_ad_cost_roi", "3pa_total_aov", "3pa_total_aov_usd", "3pa_total_revenue", "3pa_total_revenue_usd", "3pa_total_spend_cpa", "3pa_total_spend_cpa_usd", "3pa_total_spend_roi", "dynamic_creative_cost", "dynamic_creative_cost_usd", "facebook_actions", "facebook_app_installs", "facebook_likes", "facebook_page_engagement", "facebook_post_comments", "facebook_post_engagement", "facebook_post_reactions", "facebook_post_shares", "identity_fee", "identity_fee_usd", "managed_service_fee", "managed_service_fee_usd", "measurement_cost_usd", "mm_margin_share", "mm_margin_share_usd", "post_click_aov", "post_click_aov_usd", "privacy_compliance_cost", "privacy_compliance_cost_usd", "source_media_enablement_fee", "source_media_enablement_fee_usd", "source_platform_access_fee", "source_platform_access_fee_usd", "total_aov", "total_aov_usd", "udi_data_cost", "udi_data_cost_usd", "uniques", "video_close", "video_collapse", "video_companion_clicks", "video_companion_ctr", "video_companion_impressions", "video_engaged_impressions", "video_engaged_rate", "video_expand"],
    "new-to-brand": [],
    "omnichannel-attribution": [],
    "audience": [],
    "retail-attribution": [],
  },
  "reportingRowsPerPage": 10
};
